module.exports = __webpack_public_path__ + "static/information_security_policy-38a8338b30953487a0c31e7029fce9f7.pdf";